<template>
    <div>
        <div style="position: relative;background: #393940;" @click="goshow" v-if="+mediaType===1">
            <van-icon name="play-circle-o" :color="color" size="1rem" style="position:absolute;top:50%;z-index: 999;left:50%;transform:translate(-50%,-50%);"/>
            <van-image :src="videoUrl|videoposter" style="display: block;" :height="height" :width="width" :fit="fit"/>
        </div>
        <div style="position: relative;background: #393940;" @click="showImage=true" v-else-if="+mediaType===2">
            <van-image :src="videoUrl|Img" style="display: block;" :height="height" :width="width" :fit="fit"/>
        </div>
        <div style="position: relative;display: flex;align-items: center;justify-content: center;background: rgba(0,0,0,.13);padding: .2rem;font-size: .24rem;" @click="showImage=true" v-else-if="+mediaType===3">
          <div>{{videoUrl||''}}</div>
        </div>
        <van-image-preview :images="JSON.parse(videoUrl)" v-model="showImage" v-if="+mediaType===2"></van-image-preview>
        <div v-if="+mediaType===2" style="color:#00000080;font-size:12px;text-align:center;margin-top:10px;">
            点击查看详情
        </div>
        <Popup v-model="showVideo" closeable @close="onclose" position="bottom" :style="{ height: '100%' }">
            <video id="video" :src="videoUrl" x5-video-player-type="h5" playsinline="true" x5-playsinline="true" autoplay webkit-playsinline="true" height="100%" width="100%">您的浏览器不支持播放该视频！</video>
        </Popup>
    </div>
</template>
<script>
    import {Icon, Image, Popup,ImagePreview} from 'vant';

    export default {
        data() {
            return {
                showVideo: false,
                showImage: false,
                imgs:[]
            }
        },
        filters:{
            Img(val){
                try {
                    val = JSON.parse(val)
                    return val[0]
                }catch (e) {
                    console.log(e)

                }
            }
        },
        components: {
            Icon,
            VanImage: Image,
            Popup,
            [ImagePreview.Component.name]: ImagePreview.Component,
        },
        props: {
            'mediaType':{
                type:Number,
                default:1
            },
            'height': String,
            'width': String,
            'videoUrl': String,
            'fit':{
                type: String,
                default: "cover"
            },
            'color': {
                type: String,
                default: "#393940"
            },
        },
        methods: {
           goshow(){
             this.showVideo=true
             setTimeout(function(){
               var video = document.querySelector('#video');
               video.play();
             }, 1000);


           },
           onclose() {
            var video = document.querySelector('#video');
               video.pause();
           },
            playVideo: function () {
                window.location.href = this.videoUrl
            }
        }
    }
</script>
